const generateAudioLink = (
  filename: string,
) => {
    const audioLink = `https://saltire.com/speech/${filename}`
    return audioLink.replace(/ /g, "%20")
};

export default generateAudioLink;
